import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import wrapComponent from "ApplicationWrapper"
import User from "User"
import { CurrentUserContext } from "CurrentUserContext"
import CrossLogin from "CrossLogin"
import FourOhFour from "FourOhFour"
import ProtectedRoute from 'ProtectedRoute'

import LoginView from "VenueAdmin/LoginView";
import SignUpView from "VenueAdmin/SignUpView";

import ForgotPassword from "VenueAdmin/ForgotPassword"
import ResetPassword from "VenueAdmin/ResetPassword"

import DashboardView from "VenueAdmin/DashboardView"
import Profile from "VenueAdmin/Profile"

import VenueShow from "VenueAdmin/VenueShow"
import VenueEdit from "VenueAdmin/VenueEdit"

import StoreList from "VenueAdmin/StoreList"
import StoreForm from "VenueAdmin/StoreForm"
import StoreView from "VenueAdmin/StoreView"

import ProductList from "VenueAdmin/ProductList"
import ProductForm from "VenueAdmin/ProductForm"
import ProductView from "VenueAdmin/ProductView"

import DiscountList from "VenueAdmin/DiscountList"
import DiscountForm from "VenueAdmin/DiscountForm"
import DiscountView from "VenueAdmin/DiscountView"

import GratuityList from "VenueAdmin/GratuityList"
import GratuityForm from "VenueAdmin/GratuityForm"
import GratuityView from "VenueAdmin/GratuityView"

import CategoryList from "VenueAdmin/CategoryList"
import CategoryForm from "VenueAdmin/CategoryForm"
import KitchenStationsList from "VenueAdmin/KitchenStationsList"
import KitchenStationForm from "VenueAdmin/KitchenStationForm"
import CategoryView from "VenueAdmin/CategoryView"

import VenueOrderList from "VenueAdmin/VenueOrderList"
import VenueOrderView from "VenueAdmin/VenueOrderView"

import ReportList from "VenueAdmin/ReportList"
import ReportView from "VenueAdmin/ReportView"
import PaymentsReportView from "VenueAdmin/PaymentsReportView"
import SeasonReport from "VenueAdmin/SeasonReport"
import ItemsSoldReport from "VenueAdmin/ItemsSoldReport"
import DiscountsReport from "VenueAdmin/DiscountsReport"
import PrepaidCreditsReport from "VenueAdmin/PrepaidCreditsReport/PrepaidCreditsReport"
import HourlySalesReport from "VenueAdmin/HourlySalesReport"

import TerminalsList from "VenueAdmin/TerminalsList"
import APIKeysList from "VenueAdmin/APIKeysList"
import WebhooksList from "VenueAdmin/WebhooksList"
import WebhookEndpointView from "VenueAdmin/WebhookEndpointView"
import IntegrationsView from "VenueAdmin/IntegrationsView"
import VivenuIntegration from "VenueAdmin/IntegrationsView/VivenuIntegration"
import App8Integration from "VenueAdmin/IntegrationsView/App8Integration"

import CustomerList from "VenueAdmin/CustomerList"
import CustomerView from "VenueAdmin/CustomerView"
import VenuePrepaidCreditTools from "VenueAdmin/VenuePrepaidCreditTools"

import EmployeeList from "VenueAdmin/EmployeeList"
import EmployeeForm from "VenueAdmin/EmployeeForm"

import TimeLogsList from "VenueAdmin/TimeLogsList"
import TimeLogShowView from "VenueAdmin/TimeLogShowView"
import TimeLogForm from "VenueAdmin/TimeLogForm"

import ReportSchedule from "VenueAdmin/ReportSchedule"

import PayoutList from "VenueAdmin/PayoutList"
import PayoutView from "VenueAdmin/PayoutView"

const reportRoutes = () => [
  <ProtectedRoute path="/reports" exact component={wrapComponent(ReportList, "VenueAdmin")} auth={User} key="reports" />,
  <ProtectedRoute path="/reports/items_sold" exact component={wrapComponent(ItemsSoldReport, "VenueAdmin")} auth={User} key="items_sold" />,
  <ProtectedRoute path="/reports/discounts" exact component={wrapComponent(DiscountsReport, "VenueAdmin")} auth={User} key="discounts" />,
  <ProtectedRoute path="/reports/prepaid_credits" exact component={wrapComponent(PrepaidCreditsReport, "VenueAdmin")} auth={User} key="prepaid_credits" />,
  <ProtectedRoute path="/reports/hourly_sales" exact component={wrapComponent(HourlySalesReport, "VenueAdmin")} auth={User} key="hourly_sales" />,
  <ProtectedRoute path="/reports/payments/:eventId" exact component={wrapComponent(PaymentsReportView, "VenueAdmin")} auth={User} key="payments" />,
  <ProtectedRoute path="/reports/:reportId" exact component={wrapComponent(ReportView, "VenueAdmin")} auth={User} key="report" />,
  <ProtectedRoute path="/reports/season/:seasonId" exact component={wrapComponent(SeasonReport, "VenueAdmin")} auth={User} key="season" />,
  <ProtectedRoute path="/reports/:reportType/:reportId" exact component={wrapComponent(ReportView, "VenueAdmin")} auth={User} key="report-type" />
];

const fullRoutes = () => [
  <ProtectedRoute path="/" exact component={wrapComponent(DashboardView, "VenueAdmin")} auth={User} key="dashboard" />,
  <ProtectedRoute path="/venue/edit" exact component={wrapComponent(VenueEdit, "VenueAdmin")} auth={User} key="venue-edit" />,
  <ProtectedRoute path="/venue/current" exact component={wrapComponent(VenueShow, "VenueAdmin")} auth={User} key="venue-show" />,

  // Stores
  <ProtectedRoute path="/stores" exact component={wrapComponent(StoreList, "VenueAdmin")} auth={User} key="stores" />,
  <ProtectedRoute path="/stores/new" exact component={wrapComponent(StoreForm, "VenueAdmin")} auth={User} key="store-new" />,
  <ProtectedRoute path="/stores/:storeId" exact component={wrapComponent(StoreView, "VenueAdmin")} auth={User} key="store-view" />,
  <ProtectedRoute path="/stores/:storeId/edit" exact component={wrapComponent(StoreForm, "VenueAdmin")} auth={User} key="store-edit" />,

  // Products
  <ProtectedRoute path="/products" exact component={wrapComponent(ProductList, "VenueAdmin")} auth={User} key="products" />,
  <ProtectedRoute path="/products/new" exact component={wrapComponent(ProductForm, "VenueAdmin")} auth={User} key="product-new" />,
  <ProtectedRoute path="/products/:productId/edit" exact component={wrapComponent(ProductForm, "VenueAdmin")} auth={User} key="product-edit" />,
  <ProtectedRoute path="/products/:productId" exact component={wrapComponent(ProductView, "VenueAdmin")} auth={User} key="product-view" />,

  // Discounts
  <ProtectedRoute path="/discounts" exact component={wrapComponent(DiscountList, "VenueAdmin")} auth={User} key="discounts" />,
  <ProtectedRoute path="/discounts/new" exact component={wrapComponent(DiscountForm, "VenueAdmin")} auth={User} key="discount-new" />,
  <ProtectedRoute path="/discounts/:discountId/edit" exact component={wrapComponent(DiscountForm, "VenueAdmin")} auth={User} key="discount-edit" />,
  <ProtectedRoute path="/discounts/:discountId" exact component={wrapComponent(DiscountView, "VenueAdmin")} auth={User} key="discount-view" />,

  // Gratuities
  <ProtectedRoute path="/gratuities" exact component={wrapComponent(GratuityList, "VenueAdmin")} auth={User} key="gratuities" />,
  <ProtectedRoute path="/gratuities/new" exact component={wrapComponent(GratuityForm, "VenueAdmin")} auth={User} key="gratuity-new" />,
  <ProtectedRoute path="/gratuities/:gratuityId/edit" exact component={wrapComponent(GratuityForm, "VenueAdmin")} auth={User} key="gratuity-edit" />,
  <ProtectedRoute path="/gratuities/:gratuityId" exact component={wrapComponent(GratuityView, "VenueAdmin")} auth={User} key="gratuity-view" />,

  // Categories
  <ProtectedRoute path="/categories" exact component={wrapComponent(CategoryList, "VenueAdmin")} auth={User} key="categories" />,
  <ProtectedRoute path="/categories/new" exact component={wrapComponent(CategoryForm, "VenueAdmin")} auth={User} key="category-new" />,
  <ProtectedRoute path="/categories/:categoryId/edit" exact component={wrapComponent(CategoryForm, "VenueAdmin")} auth={User} key="category-edit" />,
  <ProtectedRoute path="/categories/:categoryId" exact component={wrapComponent(CategoryView, "VenueAdmin")} auth={User} key="category-view" />,

  // Kitchen Stations
  <ProtectedRoute path="/kitchen-stations" exact component={wrapComponent(KitchenStationsList, "VenueAdmin")} auth={User} key="kitchen-stations" />,
  <ProtectedRoute path="/kitchen-stations/new" exact component={wrapComponent(KitchenStationForm, "VenueAdmin")} auth={User} key="kitchen-station-new" />,
  <ProtectedRoute path="/kitchen-stations/:stationId/edit" exact component={wrapComponent(KitchenStationForm, "VenueAdmin")} auth={User} key="kitchen-station-edit" />,

  // Terminals
  <ProtectedRoute path="/terminals" exact component={wrapComponent(TerminalsList, "VenueAdmin")} auth={User} key="terminals" />,

  // API Keys
  <ProtectedRoute path="/api-keys" exact component={wrapComponent(APIKeysList, "VenueAdmin")} auth={User} key="api-keys" />,

  // Webhooks
  <ProtectedRoute path="/webhooks" exact component={wrapComponent(WebhooksList, "VenueAdmin")} auth={User} key="webhooks" />,
  <ProtectedRoute path="/webhooks/:id" exact component={wrapComponent(WebhookEndpointView, "VenueAdmin")} auth={User} key="webhook-endpoint" />,

  // Integrations
  <ProtectedRoute path="/integrations" exact component={wrapComponent(IntegrationsView, "VenueAdmin")} auth={User} key="integrations" />,
  <ProtectedRoute path="/integrations/vivenu" exact component={wrapComponent(VivenuIntegration, "VenueAdmin")} auth={User} key="integrations-vivenu" />,
  <ProtectedRoute path="/integrations/app8" exact component={wrapComponent(App8Integration, "VenueAdmin")} auth={User} key="integrations-app8" />,

  // Orders
  <ProtectedRoute path="/orders" exact component={wrapComponent(VenueOrderList, "VenueAdmin")} auth={User} key="orders" />,
  <ProtectedRoute path="/orders/:id" exact component={wrapComponent(VenueOrderView, "VenueAdmin")} auth={User} key="order-view" />,

  // Customers
  <ProtectedRoute path="/customers" exact component={wrapComponent(CustomerList, "VenueAdmin")} auth={User} key="customers" />,
  <ProtectedRoute path="/customers/:customerId" exact component={wrapComponent(CustomerView, "VenueAdmin")} auth={User} key="customer-view" />,

  // Prepaid Credits
  <ProtectedRoute path="/prepaid_credits" exact component={wrapComponent(VenuePrepaidCreditTools, "VenueAdmin")} auth={User} key="prepaid-credits" />,

  // Employees
  <ProtectedRoute path="/employees" exact component={wrapComponent(EmployeeList, "VenueAdmin")} auth={User} key="employees" />,
  <ProtectedRoute path="/employees/new" exact component={wrapComponent(EmployeeForm, "VenueAdmin")} auth={User} key="employee-new" />,
  <ProtectedRoute path="/employees/:employeeId/edit" exact component={wrapComponent(EmployeeForm, "VenueAdmin")} auth={User} key="employee-edit" />,

  // Payouts (read-only; not available to store-limited users — see fullRoutes guard)
  <ProtectedRoute path="/payouts" exact component={wrapComponent(PayoutList, "VenueAdmin")} auth={User} key="payouts" />,
  <ProtectedRoute path="/payouts/:id" exact component={wrapComponent(PayoutView, "VenueAdmin")} auth={User} key="payout-view" />,

  // Time Logs
  <ProtectedRoute path="/time_logs" exact component={wrapComponent(TimeLogsList, "VenueAdmin")} auth={User} key="time-logs" />,
  <ProtectedRoute path="/time_logs/new" exact component={wrapComponent(TimeLogForm, "VenueAdmin")} auth={User} key="time-log-new" />,
  <ProtectedRoute path="/time_logs/:id/edit" exact component={wrapComponent(TimeLogForm, "VenueAdmin")} auth={User} key="time-log-edit" />,
  <ProtectedRoute path="/time_logs/:id" exact component={wrapComponent(TimeLogShowView, "VenueAdmin")} auth={User} key="time-log-view" />,
];

export default props => {
  return (
    <CurrentUserContext.Consumer>
      {({ user }) => (
        <Router>
          <Switch>
            <Route path="/login" exact component={wrapComponent(LoginView, "Auth")} />
            <Route path="/forgot-password" exact component={wrapComponent(ForgotPassword, "Auth")} />
            <Route path="/password-reset" exact component={wrapComponent(ResetPassword, "Auth")} />
            <Route path="/sign-up/:invitationToken" exact component={wrapComponent(SignUpView, "Auth")} />
            <ProtectedRoute path="/profile" exact component={wrapComponent(Profile, "VenueAdmin")} auth={User} />
            <ProtectedRoute path="/report-schedule" exact component={wrapComponent(ReportSchedule, "VenueAdmin")} auth={User} />

            {reportRoutes()}
            {user?.storeLimited ? <Redirect from='/' to='/reports' /> : fullRoutes()}

            <Route path="/cross-login" exact component={CrossLogin} />
            <Route path="/*" component={wrapComponent(FourOhFour)} />
          </Switch>
        </Router>
      )}
    </CurrentUserContext.Consumer>
  )
};
